import { List, Toast } from "antd-mobile";
import React, { useContext, useState, useEffect } from "react";
import PsContext from "../../context";
import { Card, Button } from "react-bootstrap";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { SpinLoading, Form } from "antd-mobile";
import PersonalDetail from "./personalDetails";

const StaffProfile = (props) => {
    const context = useContext(PsContext);
    const [staffdata, setStaffdata] = useState([]);
    const [selectedStaffdata, setSelectedStaffdata] = useState(null);
    const [dept, setDept] = useState([]);
    const [designation, setDesgnation] = useState([]);
    const [selectDept, setSelectDept] = useState("All");
    const [selectDesignation, setSelectDesignation] = useState("All");
    const [showSearchBox, setShowSearchBox] = useState(true);

    useEffect(() => {
        loadDept();
        loadDesignation();
    }, []);

    const loadStaff = () => {
        context.setLoader(true);
        let form = new FormData();
        if (selectDept !== "All") {
            form.append("department", selectDept);
        }
        if (selectDesignation !== "All") {
            form.append("designation", selectDesignation);
        }

        axios.post(ServiceUrl.MOB.EMP_LIST, form).then((res) => {
            if (res["data"].status === "1") {
                setStaffdata(res["data"].data);
                setShowSearchBox(false);
            } else {
                setStaffdata([]);
                Toast.show({ content: res["data"].message || "Error" });
            }
            context.setLoader(false);
        });
    };

    const loadDept = () => {
        context.setLoader(true);
        axios.post(ServiceUrl.MOB.LIST_DEPARTMENT).then((res) => {
            if (res["data"].status === "1") {
                setDept([{ id: "All", department: "All" }, ...res["data"].data]);
            } else {
                Toast.show({ content: res["data"].message || "Error" });
            }
            context.setLoader(false);
        });
    };

    const loadDesignation = () => {
        context.setLoader(true);
        axios.get(ServiceUrl.MOB.LIST_DESIGNATIONS).then((res) => {
            if (res["data"].status === "1") {
                setDesgnation([{ id: "All", designation_name: "All" }, ...res["data"].data]);
            } else {
                Toast.show({ content: res["data"].message || "Error" });
            }
            context.setLoader(false);
        });
    };

    const handleButtonClick = (item) => {
        setSelectedStaffdata(item);
    };

    const handleDeptChange = (e) => {
        setSelectDept(e.target.value);
    };

    const handleDesignationChange = (e) => {
        setSelectDesignation(e.target.value);
    };

    const handleSearch = () => {
        loadStaff();
    };

    // const handleBack = () => {
    //     setShowSearchBox(true);
    //     setSelectedStaffdata(null); 
    // };

    return (
        <>
            <Header hideLogoText={true} title="Staff Profile" />

            {showSearchBox ? (
                <div className="container-sm py-md-3">
                    <Card>
                        <Card.Body>
                            <Form
                                name="from"
                                footer={
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        size="sm"
                                        className="w-100"
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </Button>
                                }
                            >
                                <Form.Item name="department" label={<span>Department</span>}>
                                    <select
                                        className="form-select form-select-sm fw-bold"
                                        value={selectDept}
                                        onChange={handleDeptChange}
                                    >
                                        {dept.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.department}
                                            </option>
                                        ))}
                                    </select>
                                </Form.Item>
                                <Form.Item name="designation" label={<span>Designation</span>}>
                                    <select
                                        className="form-select form-select-sm fw-bold"
                                        value={selectDesignation}
                                        onChange={handleDesignationChange}
                                    >
                                        {designation.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.designation_name}
                                            </option>
                                        ))}
                                    </select>
                                </Form.Item>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            ) : selectedStaffdata ? (
                <>
                    {/* <Button variant="secondary" onClick={handleBack} className="mb-3">
                        Back to Search
                    </Button>
                     */}
                    <PersonalDetail dataSource={selectedStaffdata} />
                </>
            ) : (
                <div className="container-sm py-md-3">
                    {staffdata.length > 0 ? (
                        <List>
                            {staffdata.map((item) => (
                                <List.Item
                                    key={item.emp_id}
                                    className="ps-3"
                                    onClick={() => handleButtonClick(item)}
                                    style={{ fontSize: "12px", cursor: "pointer" }}
                                >
                                    <tr>
                                        <td>{item.emp_name} - {item.designation_name}</td>
                                    </tr>
                                    <tr>
                                        <td>{item.emp_personal_mobile}</td>
                                    </tr>
                                </List.Item>
                            ))}
                        </List>
                    ) : (
                        <div className="text-center py-3">
                            <p>No data found</p>
                        </div>
                    )}

                    {/* <Button variant="secondary" onClick={handleBack} className="mt-3">
                        Back to Search
                    </Button> */}
                </div>
            )}
        </>
    );
};

export default StaffProfile;
